import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { PowerSupplyCpn2 } from "@psnb/psnb-api";
import { PowerSupplyService } from "@psnb/services";
import { NumberOnlyValidation } from '../numberOnly.validation';
import { CommonService } from '../../../common/common.service';
import { PowerSupplyMoveErrorDialog } from 'desktop/power-supply/power-supply-move/power-supply-move-error-dialog';

@Component({
  selector: 'nwt-power-supply-edit-supply',
  templateUrl: './power-supply-edit-supply.component.html',
  styleUrls: ['./power-supply-edit-supply.component.scss']
})
export class PowerSupplyEditSupplyComponent implements OnInit {

  supplyFormGroup: FormGroup;
  supplyNumber: any;
  powerSupplyId: number = 0;
  id: number = 0;
  supplyName: string = '';
  sysContact: string = '';
  sysLocation; string = '';
  deviceIds: string[] = ['1', '2', '3', '4', '5', 'Not an Alpha Supply'];
  powerSupplyModels: string[] = [];
  eventLogs: string[] = ['Yes', 'No'];
  acInputVoltageRatings: string[] = ['120VAC', '210VAC', '240VAC'];
  acOutputVoltageRatings: string[] = ['60VAC', '75VAC', '90VAC'];
  currentAmpRatings: string[] = ['4.8Amp', '8Amp', '15Amp', '18Amp', '22Amp', '24Amp'];
  currentAmpOutputUses: string[] = ['Output#1', 'Output#2', 'DualOutput'];
  pimDocsInstalled: string[] = ['Yes', 'No'];
  alphaAPPCardsInstalled: string[] = ['Yes', 'No'];
  controllerCardTypes: string[] = [];
  dcReadys: string[] = ['Yes', 'No'];
  showProgressBar: boolean = false;
  telemetryThresholdProfileData : Array<string> = [];
  powerSupplyAlertProfile = '';
  ampRatings: any[] = [];
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private fb: FormBuilder,
    private powerSupplyService: PowerSupplyService,
    private commonService: CommonService,
    public dialogRef: MatDialogRef<PowerSupplyEditSupplyComponent>,
    private ref: ChangeDetectorRef,
    private dialog: MatDialog,
  ) { }

  ngOnInit() {
    this.getTelemetryThresholdsAlertProfileData();
    this.showProgressBar = true;
    this.supplyNumber = this.data.supplyNumber;
    this.powerSupplyModels = this.data.powerSupplyModels;
    this.controllerCardTypes = this.data.controlCardTypes;
    this.powerSupplyId = this.data.id;
    this.supplyName = this.data.supplyName;
    this.sysContact = this.data.sysContact;
    this.sysLocation = this.data.sysLocation;
    this.ampRatings = this.data.ampRatings;
    this.supplyFormGroup = this.fb.group({
      //deviceId: [''],
      powerSupplyModel: ['', Validators.required],
      acInputVoltageRating: ['', Validators.required],
      acOutputVoltageRating: ['', Validators.required],
      currentAmp: ['', Validators.required],
      serialNumber: [''],
      egisNumber: [''],
      globalId: [''],
      powerSupplyAlertProfile: [{ value: this.powerSupplyAlertProfile, disabled: true }]
    });

    if (this.powerSupplyId != null && this.powerSupplyId != 0) {
      this.powerSupplyService.getPowerSupplyCpnByPowerSupplyId(this.powerSupplyId, this.supplyNumber).subscribe(res => {
        this.powerSupplyAlertProfile = res.powerSupplyAlertProfile;
        if (res.id != 0 && res.id != null) {
          this.id = res.id;
          this.supplyFormGroup.patchValue({
            //deviceId: res.deviceId,
            powerSupplyModel: res.powerSupplyModel,
            serialNumber: res.serialNumber,
            //powerSupplyEventCount: res.powerSupplyEventCount,
            //eventLogCleared: res.eventLogCleared,
            //totalRunDays: res.totalRunDays,
            acInputVoltageRating: res.acInputVoltageRating,
            acOutputVoltageRating: res.acOutputVoltageRating,
            currentAmp: res.currentAmpRating,
            powerSupplyAlertProfile: this.powerSupplyAlertProfile,
            egisNumber: res.egisNumber,
            globalId: res.globalId,
            //currentAmpOutputUsed: res.currentAmpOutputUsed,
            //pimDocInstalled: res.pimAlphaDocInstalled,
            //alphaAPPCardInstalled: res.alphaAppsCardInstalled,
            //controllerCardType: res.controllerCardType,
            //dcReady: res.dcReady,
            //outputCurrentOutput1: res.outputCurrentAmps1,
            //outputCurrentOutput2: res.outputCurrentAmps2,
            //firmwareVersion: res.firmwareVersion,
            //dateCode: res.dateCode,
            //refurbDate: res.refurbDate
          });
          this.changePSAlertProfiles()
          this.markAsTouched(this.supplyFormGroup);
          this.ref.detectChanges();
        } else this.id = 0;
        this.markAsTouched(this.supplyFormGroup);
        this.ref.detectChanges();
        this.showProgressBar = false;
      }, err => {
        this.markAsTouched(this.supplyFormGroup);
        this.ref.detectChanges();
        this.showProgressBar = false;
      });
    } else this.showProgressBar = false;
  }

  getTelemetryThresholdsAlertProfileData() {
    this.powerSupplyService.getTelemetryThresholdsAlertProfile().subscribe((res) => {
      if(res != null && res.length > 0)
        this.telemetryThresholdProfileData = res;
    });
  }


  saveSupplyChanges() {
    if (!this.checkValidProfile()) {
      let errMessage = "Power Supply Alert Profile is Invalid.";
      this.openErrorDialog(errMessage);
      return;
    } else {
      this.showProgressBar = true;
      const jsonPowerSupplyCpn2: PowerSupplyCpn2 = {};
      //jsonPowerSupplyCpn2.deviceId = this.supplyFormGroup.value.deviceId;
      jsonPowerSupplyCpn2.powerSupplyId = this.powerSupplyId;
      jsonPowerSupplyCpn2.powerSupplyModel = this.supplyFormGroup.value.powerSupplyModel;
      jsonPowerSupplyCpn2.serialNumber = this.supplyFormGroup.value.serialNumber;
      //jsonPowerSupplyCpn2.powerSupplyEventCount = this.supplyFormGroup.value.powerSupplyEventCount;
      //jsonPowerSupplyCpn2.eventLogCleared = this.supplyFormGroup.value.eventLogCleared;
      //jsonPowerSupplyCpn2.totalRunDays = this.supplyFormGroup.value.totalRunDays;
      jsonPowerSupplyCpn2.acInputVoltageRating = this.supplyFormGroup.value.acInputVoltageRating;
      jsonPowerSupplyCpn2.acOutputVoltageRating = this.supplyFormGroup.value.acOutputVoltageRating;
      jsonPowerSupplyCpn2.currentAmpRating = this.supplyFormGroup.value.currentAmp;

      jsonPowerSupplyCpn2.powerSupplyAlertProfile = this.powerSupplyAlertProfile;
      jsonPowerSupplyCpn2.egisNumber = this.supplyFormGroup.value.egisNumber;
      jsonPowerSupplyCpn2.globalId = this.supplyFormGroup.value.globalId;
      //jsonPowerSupplyCpn2.currentAmpRating = this.supplyFormGroup.value.currentAmpRating;
      //jsonPowerSupplyCpn2.currentAmpOutputUsed = this.supplyFormGroup.value.currentAmpOutputUsed;
      //jsonPowerSupplyCpn2.pimAlphaDocInstalled = this.supplyFormGroup.value.pimDocInstalled;
      //jsonPowerSupplyCpn2.alphaAppsCardInstalled = this.supplyFormGroup.value.alphaAPPCardInstalled;
      //jsonPowerSupplyCpn2.controllerCardType = this.supplyFormGroup.value.controllerCardType;
      //jsonPowerSupplyCpn2.dcReady = this.supplyFormGroup.value.dcReady;
      //jsonPowerSupplyCpn2.outputCurrentAmps1 = this.supplyFormGroup.value.outputCurrentOutput1;
      //jsonPowerSupplyCpn2.outputCurrentAmps2 = this.supplyFormGroup.value.outputCurrentOutput2;
      //jsonPowerSupplyCpn2.firmwareVersion = this.supplyFormGroup.value.firmwareVersion;
      //jsonPowerSupplyCpn2.dateCode = this.supplyFormGroup.value.dateCode;
      //jsonPowerSupplyCpn2.refurbDate = this.supplyFormGroup.value.refurbDate;
      jsonPowerSupplyCpn2.supplyNumber = this.supplyNumber;

      if (this.id == 0) {
        this.powerSupplyService.createPowerSupplyCpn(jsonPowerSupplyCpn2).subscribe(res => {
          this.showProgressBar = false;
          if (res.success === true) {
            const activity = `PowerSupply Edit - Supply#${this.supplyNumber} Save`;
            const message = `PowerSupply Supply#${this.supplyNumber} Create Success. Data: ${JSON.stringify(jsonPowerSupplyCpn2)}`;
            this.commonService.loggerPost(message, activity, 3);
            this.dialogRef.close('CREATED');
          } else {
            const activity = `PowerSupply Edit - Supply#${this.supplyNumber} Save - Error`;
            const message = `PowerSupply Supply#${this.supplyNumber} Create Error. Data: ${JSON.stringify(jsonPowerSupplyCpn2)}`;
            this.commonService.loggerPost(message, activity, 3);
            this.dialogRef.close('FAILED');
          }
        },
        err => {
          const activity = `PowerSupply Edit - Supply#${this.supplyNumber} Save - Error`;
          const message = `PowerSupply Supply#${this.supplyNumber} Create Error. Data: ${JSON.stringify(jsonPowerSupplyCpn2)}`;
          this.commonService.loggerPost(message, activity, 3);
          this.dialogRef.close('FAILED');
          this.showProgressBar = false;
        });
      } else {
        jsonPowerSupplyCpn2.id = this.id;
        this.powerSupplyService.updatePowerSupplyCpn(jsonPowerSupplyCpn2).subscribe(res => {
          this.showProgressBar = false;
          if (res.success === true) {
            const activity = `PowerSupply Edit - Supply#${this.supplyNumber} Save`;
            const message = `PowerSupply Supply#${this.supplyNumber} Update Success. Data: ${JSON.stringify(jsonPowerSupplyCpn2)}`;
            this.commonService.loggerPost(message, activity, 3);
            this.dialogRef.close('UPDATED');
          } else {
            const activity = `PowerSupply Edit - Supply#${this.supplyNumber} Save - Error`;
            const message = `PowerSupply Supply#${this.supplyNumber} Update Error. Data: ${JSON.stringify(jsonPowerSupplyCpn2)}`;
            this.commonService.loggerPost(message, activity, 3);
            this.dialogRef.close('FAILED');
          }
        },
        err => {
          const activity = `PowerSupply Edit - Supply#${this.supplyNumber} Save - Error`;
          const message = `PowerSupply Supply#${this.supplyNumber} Update Error. Data: ${JSON.stringify(jsonPowerSupplyCpn2)}`;
          this.commonService.loggerPost(message, activity, 3);
          this.dialogRef.close('FAILED');
          this.showProgressBar = false;
        });
      }
    }
  }
  changePSAlertProfiles() {
    let acInputVoltage = this.supplyFormGroup.value.acInputVoltageRating;
    let outputVoltage = this.supplyFormGroup.value.acOutputVoltageRating;
    let inputCurrent = this.supplyFormGroup.value.currentAmp;
    let numberOfBatteries = this.data.noOfBatteries;
    // alert(acInputVoltage)
    // alert(outputVoltage)
    // alert(inputCurrent)
    // alert(numberOfBatteries)
    // alert(this.data.division)
    this.powerSupplyAlertProfile = this.commonService.getUnifiedPSAlertProfile(acInputVoltage,
      outputVoltage, inputCurrent, numberOfBatteries, this.data.division);
  }

  checkValidProfile(): boolean{
    return this.telemetryThresholdProfileData.includes(this.powerSupplyAlertProfile);
  }

  openErrorDialog(message: string) {
    this.dialog.open(PowerSupplyMoveErrorDialog, {
      data: {
        message: message ? message : ''
      },
      disableClose: true
    })
  }
  cancel() {
    this.dialogRef.close('OK');
  }

  markAsTouched(formGroup: any): void {
    Object.keys(formGroup.controls).forEach((key: string) => {
      const abstractControl = formGroup.get(key);
      if (abstractControl instanceof FormGroup || abstractControl instanceof FormArray) {
        this.markAsTouched(abstractControl);
      } else {
        abstractControl.markAsTouched();
        abstractControl.markAsDirty();
      }
    })
  }
}
